<template>
  <div class="pagination-wrapper" v-if="totalCount > 0">
    <div class="pagination-info pc-only">
      <span class="total-count">共{{ totalCount }}{{ unit }}</span>
    </div>

    <div class="page-size-selector pc-only" v-if="showPageSizeSelector">
      <select
        v-model="localPageSize"
        @change="handlePageSizeChange"
        class="page-size-select"
      >
        <option v-for="size in pageSizeOptions" :key="size" :value="size">
          {{ size }}条/页
        </option>
      </select>
    </div>

    <div class="pagination">
      <button
        class="prev-page"
        :class="{ disabled: Number(currentPage) === 1 }"
        :disabled="Number(currentPage) === 1"
        @click="changePage(Number(currentPage) - 1)"
      >
        &lt;
      </button>

      <button
        v-for="(page, index) in pages"
        :key="`page-${page}-${index}`"
        :class="[
          'page-button',
          {
            active: Number(page) === Number(currentPage) && page !== '...',
            disabled: page === '...',
          },
        ]"
        :disabled="page === '...'"
        @click="changePage(page)"
      >
        {{ page }}
      </button>

      <button
        class="next-page"
        :class="{ disabled: Number(currentPage) === Number(totalPages) }"
        :disabled="Number(currentPage) === Number(totalPages)"
        @click="changePage(Number(currentPage) + 1)"
      >
        &gt;
      </button>

      <div class="pagination-info mobile-only">
        <span class="total-count">共{{ totalCount }}{{ unit }}</span>
      </div>
    </div>

    <div class="jump-to-page pc-only" v-if="showJumpToPage">
      <span>前往</span>
      <input
        v-model.number="inputPage"
        type="number"
        min="1"
        :max="totalPages"
        @keydown.enter="jumpToPage"
        class="jump-input"
      />
      <span>页</span>
    </div>
  </div>
</template>

<script setup>
import { usePagination } from '@/shared/composables/usePagination'

const props = defineProps({
  totalPages: {
    type: Number,
    required: true,
  },
  currentPage: {
    type: Number,
    required: true,
  },
  totalCount: {
    type: Number,
    default: 0,
  },
  pageSize: {
    type: Number,
    default: 10,
  },
  showPageSizeSelector: {
    type: Boolean,
    default: true,
  },
  showJumpToPage: {
    type: Boolean,
    default: true,
  },
  unit: {
    type: String,
    default: '部',
  },
})

const emit = defineEmits(['change-page', 'change-page-size'])

const {
  inputPage,
  localPageSize,
  pageSizeOptions,
  pages,
  changePage,
  jumpToPage,
  handlePageSizeChange,
} = usePagination(props, emit)
</script>

<style scoped src="@/shared/styles/Pagination.css"></style>
